import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-ventas-f29',
  templateUrl: './ventas-f29.component.html',
  styleUrls: ['./ventas-f29.component.scss']
})
export class VentasF29Component {
  @Input() data: any = null;

  public showData: boolean = false;
  public panelOpenState: any = {};

  constructor() { }

  ngOnInit(): void {
    if(this.data && this.data.length > 0) {

      this.openAll();

      this.showData = true;
    }
  }

  openAll(): void {
    for(const element of this.data) {
      this.panelOpenState[element?.title] = true;
    }
  }
}
